import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function doLogin(payload) {
    const result = await axios.post(apiUrl + "/admin/login",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function doLogout(payload) {
    const result = await axios.post(apiUrl + "/admin/logout",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getAccountUpdate(payload) {
    const result = await axios.post(apiUrl + "/admin/getaccount/update",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const LoginService = {
    doLogin,
    getAccountUpdate,
    doLogout
}
